import { Component, Injectable, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DrawerLocations } from 'src/app/models/configurators-2d/applications/closet-doors-standard/drawer-locations';
import { Location } from 'src/app/models/configurators-2d/location';
import { ClosetDoorsCustomService } from 'src/app/services/configurators-2d/applications/closet-doors-custom.service';
import { ClosetDoorsCustomConfiguratorItem } from '../../../configurator/applications/closet-doors-custom-configurator-item';
import { IBaseComponent } from '../../../configurator/i-base-component';

@Component({
  selector: 'ng-closet-doors-custom-environment',
  templateUrl: './environment.component.html',
})
@Injectable({
  providedIn: 'root',
})
export class ClosetDoorsCustomEnvironmentComponent
  extends ClosetDoorsCustomConfiguratorItem
  implements OnInit, OnChanges, IBaseComponent
{
  locations: Location[];
  drawerLeft: boolean;
  drawerCenter: boolean;
  drawerRight: boolean;

  baseImgURL = undefined;
  currentLang: string;

  constructor(
    private translate: TranslateService,
    closetDoorsCustomService: ClosetDoorsCustomService
  ) {
    super(closetDoorsCustomService);
    this.baseImgURL = this.service.apiUrl;
    this.currentLang = this.translate.getBrowserLang();
  }

  ngOnInit(): void {
    this.service.getLocations().then(locations => {
      this.locations = [...locations].sort((a, b) => a.displayOrder - b.displayOrder);
      if (!this.configuration.location && this.locations) {
        this.selectLocation(this.locations.find(_ => _));
      }
    });
  }

  selectLocation(location: Location) {
    this.configuration.location = location;
  }

  isEmplacementSelected(id: number) {
    return this.configuration.location?.id === id;
  }

  ngOnChanges(changes: SimpleChanges): void {
    switch (this.configuration.drawerLocations) {
      case 2:
        this.drawerLeft = true;
        this.drawerCenter = false;
        this.drawerRight = false;
        break;
      case 4:
        this.drawerLeft = false;
        this.drawerCenter = true;
        this.drawerRight = false;
        break;
      case 6:
        this.drawerLeft = true;
        this.drawerCenter = true;
        this.drawerRight = false;
        break;
      case 8:
        this.drawerLeft = false;
        this.drawerCenter = false;
        this.drawerRight = true;
        break;
      case 10:
        this.drawerLeft = true;
        this.drawerCenter = false;
        this.drawerRight = true;
        break;
      case 12:
        this.drawerLeft = false;
        this.drawerCenter = true;
        this.drawerRight = true;
        break;
      case 14:
        this.drawerLeft = true;
        this.drawerCenter = true;
        this.drawerRight = true;
        break;
      default:
        this.drawerLeft = false;
        this.drawerCenter = false;
        this.drawerRight = false;
        break;
    }
  }

  isNextButtonActive(): boolean {
    return this.configuration?.location != undefined;
  }
  checkPageChangeCapability(): boolean {
    return true;
  }

  get hasDrawers() {
    return this.configuration?.hasDrawers;
  }

  set hasDrawers(hasDrawers: boolean) {
    this.configuration.hasDrawers = hasDrawers;
    this.onChangeDrawerLocation();
  }

  onChangeDrawerLocation() {
    let drawers = 0;

    if (this.drawerLeft) drawers += 2;
    if (this.drawerCenter) drawers += 4;
    if (this.drawerRight) drawers += 8;

    this.configuration.drawerLocations = drawers as DrawerLocations;
  }
}
